import { useEffect, useState } from 'react';

import { routes } from '~/components/app/appMainRoutes';
import { useTargetMarketsQuery } from '~/generated/graphql';
import useQueryParams from '~/hooks/useQueryParams';
import history from '~/lib/history';
import { trackEvent } from '~/lib/tracking';

export type Search = {
  country?: string[];
  description?: string[];
  employees?: string[];
  industry?: string[];
  raised?: string[];
  tag?: string[];
  tech?: string[];
  type?: string[];
};

export type SearchQuery = Search | null;

export type SetTargetMarketParams = {
  search: SearchQuery;
  id: string | null;
};

export const useTargetMarket = () => {
  const { data: targetMarketsData } = useTargetMarketsQuery();

  const [id, setId] = useState<string | null>(null);
  const [search, setSearch] = useState<SearchQuery>(null);
  const [modifiedNotSaved, setModifiedNotSaved] = useState(false);

  const queryParams = useQueryParams();
  const idQueryParam = queryParams.get('id');

  const goToList = (newID: string) => {
    if (newID) {
      setId(newID);
      history.push(`${routes.targetMarkets}?id=${newID}`);
    }
  };

  const targetMarketLists = targetMarketsData?.targetMarkets?.targetMarkets;
  const targetMarketId = targetMarketLists?.[0]?.id;

  useEffect(() => {
    goToList(idQueryParam || targetMarketId);
  }, []);

  const newSetSearch = (search: SearchQuery) => {
    setSearch(search);
    setModifiedNotSaved(true);
  };

  const setTargetMarket = ({ search, id }: SetTargetMarketParams) => {
    setSearch(search);
    setId(id);
    setModifiedNotSaved(false);

    if (id) {
      goToList(id);
      trackEvent('target_market_selected', { id, search });
    }
  };

  return {
    id,
    modifiedNotSaved,
    search,
    setSearch: newSetSearch,
    setTargetMarket,
  };
};
